export const CORPORATE_BOND_TAB = {
  SCREENER: 'screener',
  MY_SELECTION: 'my-selection',
} as const;

export type CorporateBondTabType = typeof CORPORATE_BOND_TAB[keyof typeof CORPORATE_BOND_TAB];

interface ITabConfig {
  id: CorporateBondTabType,
  name: string,
  hasSearch: boolean,
  hasBadge: boolean,
}

export const CORPORATE_BS_TABS_CONFIG: Record<CorporateBondTabType, ITabConfig> = {
  [CORPORATE_BOND_TAB.SCREENER]: {
    id: CORPORATE_BOND_TAB.SCREENER,
    name: 'Screener',
    hasSearch: true,
    hasBadge: false,
  },
  [CORPORATE_BOND_TAB.MY_SELECTION]: {
    id: CORPORATE_BOND_TAB.MY_SELECTION,
    name: 'My Selections',
    hasSearch: false,
    hasBadge: true,
  },
} as const;
